export default "__VITE_ASSET__73af0284__"